/** Catalog `colliderType`: 0 Box, 1 Mesh, 2 Plane. */
export const COLLIDER_TYPE_PLANE = 2;

/** `colliderType === 2` için tabanı 0.01 cm yukarı al (sahne birimi metre). */
export const PLANE_COLLIDER_PIVOT_LIFT_M = 0.015;

export function colliderTypeOf(
  data?: { colliderType?: number | string | null } | null,
): number {
  const value = Number(data?.colliderType);
  return Number.isFinite(value) ? value : 0;
}

export function isPlaneCollider(
  data?: { colliderType?: number | string | null } | null,
): boolean {
  return colliderTypeOf(data) === COLLIDER_TYPE_PLANE;
}

export function planeColliderPivotLiftM(
  data?: { colliderType?: number | string | null } | null,
): number {
  return isPlaneCollider(data) ? PLANE_COLLIDER_PIVOT_LIFT_M : 0;
}
